<template>
<v-container style="height:100%; background-color:#1d1d1d">
  <v-layout xs12 column wrap justify-center>
    <v-flex xs12 fluid style="margin-bottom:15px">
      <v-icon style="font-size:24px;color:#643dff;">fas fa-robot</v-icon><span class="pl-2 ml-2" style="font-size:13px; text-transform:uppercase;color:#643dff">Chatbot</span>
    </v-flex>
      <v-layout row xs12>
        <v-flex xs2>
          <span style="font-size:13px; text-transform:uppercase;">Service</span> 
          <v-flex>
            <v-select dark
              v-model="selectService"
              :items="services"
              persistent-hint
              return-object
              @input="selectedService"
            ></v-select>
          </v-flex>
        </v-flex>
        
        <v-flex xs2 class="mx-3">
          <span style="font-size:13px; text-transform:uppercase;">Type</span>
          <v-select dark
              v-model="selectType"
              :items="types"
              persistent-hint
              return-object
              @input="selectedType"
            ></v-select>
        </v-flex>
        <v-flex xs3>
          <span style="font-size:13px; text-transform:uppercase;">Number of Chat</span>
           <v-layout row>
             <v-flex xs3 sm4>
             <v-text-field   
              style="width:100px"
              class="inputPrice"
              v-model="numberOfCalls.value"
              dark outline single-line
              @change="changedNumberOfCalls"              
              >
             </v-text-field></v-flex>
             <v-flex xs3 sm3>
               <v-layout column>
                <v-btn class="ma-0" style="background-color:#7F5FFF; width:25px; height:25px" fab dark  v-on:click="numberOfCalls.value++"><v-icon style="font-size:20px">keyboard_arrow_up</v-icon></v-btn>
                <v-btn class="mx-0 mb-0 mt-1" style="background-color:#7F5FFF; width:25px; height:25px"  fab dark  v-on:click="numberOfCalls.value--"><v-icon style="font-size:20px">keyboard_arrow_down</v-icon></v-btn>
               </v-layout>
             </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs5></v-flex>
      </v-layout>   

      <v-flex xs12>
        <span style="font-size:13px; text-transform:uppercase;">Character</span>
        <v-flex>
          <v-btn style="background-color:#7F5FFF;" dark round @click="selectCharacter">{{ selectedCharacter.value ||  'New Character' }}</v-btn>
        </v-flex>
        <v-flex>
          <v-btn style="background-color:#7F5FFF;" dark round @click="listCharacter" v-if="!selectedCharacter.value">Existing character</v-btn>
        </v-flex>
        <v-flex v-for="(character, index) in characters" :key="index">
          <v-btn style="background-color:#7F5FFF;" dark round @click="importCharacter(characters[index])" v-if="!selectedCharacter.value">{{ character.name }}</v-btn>
        </v-flex>
      </v-flex>
  </v-layout>
</v-container>
</template>
<script>
import { db } from '../../firebaseDB'
export default {
  props: ['currentNode', 'editor', 'diagramData'],
  data () {
    return {
      selectService: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'serviceName').value,
      selectType: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'typeName'),
      selectedCharacter: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'selectedCharacter'),
      numberOfCalls: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfCalls'),
      services: ['Mitzuku'],
      types: ['Natural'],
      characters: []
    }
  },
  watch: {
    currentNode () {
      this.selectService = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'serviceName').value
      this.selectedCharacter = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'selectedCharacter')
      this.selectType = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'typeName')
      this.numberOfCalls = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfCalls')
      if (this.selectedCharacter.value) {
        this.editor.signals.panelNodeSelected.dispatch(this.currentNode)
      }
    }
  },
  mounted () {
    if (this.selectedCharacter.value) {
      this.editor.signals.panelNodeSelected.dispatch(this.currentNode)
    }
  },
  methods: {
    selectedService (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'serviceName')
      selectedValue.value = value
    },
    selectedType (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'typeName')
      selectedValue.value = value
    },
    changedNumberOfCalls (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'numberOfCalls')
      if (value < 0) {
        value = 0
      }
      selectedValue.value = value
    },
    selectCharacter () {
      this.editor.signals.showSelector.dispatch(this.currentNode)
    },
    listCharacter () {
      if (this.foundPreviousScene(this.currentNode.data.key) !== -1) {
        let prevScene = this.foundPreviousScene(this.currentNode.data.key)
        let prevSeneTimelineId = prevScene.timelineId
        this.getTimelineById(prevSeneTimelineId)
          .then(timeline => {
            timeline.elements = timeline.elements ? timeline.elements : []
            if (timeline.elements.length !== 0) {
              this.characters = timeline.elements.filter(ele => ele.type === 'Character')
              // let firstCharacter = this.characters[0]
              // let characterNode = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'selectedCharacter')
              // characterNode.value = firstCharacter.name
            }
          })
      }
    },
    importCharacter (character) {
      this.selectedCharacter.value = character.name
      this.editor.signals.panelNodeSelected.dispatch(this.currentNode)
    },
    foundPreviousScene (key) {
      let linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === key)
      // continue to track its upper layer throngh the link, till a scene node is found
      while (typeof linkFromThisKey !== 'undefined') {
        let prevNodeKey = linkFromThisKey.from
        let prevNode = this.diagramData.nodeDataArray.find(node => node.key === prevNodeKey)
        if (prevNode.category === 'Scene') {
          return prevNode
        }
        linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === prevNode.key)
      }
      return -1
    },
    getTimelineById (timelineId) {
      return db.ref(`timelines/${timelineId}`).once('value').then(snapshot => snapshot.val())
    }
  }
}
</script>
<style lang="stylus" scoped>
  .flex {
    color: white;
  }
.inputPrice input[type='number'] {
    -moz-appearance:textfield;
}
.inputPrice input::-webkit-outer-spin-button,
.inputPrice input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

</style>


// WEBPACK FOOTER //
// src/components/story-edit-view/chatbotPanel.vue